import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReactSelect from 'react-select';
import TeamHeader from '../components/TeamHeader';

const Step3 = ({
  teamName,
  teamDescription,
  students,
  setStudents,
  studentsData,
  teacher,
  setTeacher,
  teachersData,
  setShouldContinue
}) => {
  //these are used to store <select> options formatted according to React-select
  const [studentsOptions, setStudentsOptions] = useState([]);
  const [teachersOptions, setTeachersOptions] = useState([]);

  useEffect(() => {
    setStudentsOptions([]);
    Object.entries(studentsData).forEach(([studentCode, studentObject]) => {
      if (!studentObject.deleted) {
        const studentOptionObject = {
          value: studentCode,
          label: `${studentObject.name} - ${studentObject.price} crediti`
        };
        setStudentsOptions(studentsOptions => [
          ...studentsOptions,
          studentOptionObject
        ]);
      }
    });

    setTeachersOptions([]);
    Object.entries(teachersData).forEach(([teacherCode, teacherObject]) => {
      if (!teacherObject.deleted) {
        const teacherOptionObject = {
          value: teacherCode,
          label: `${teacherObject.name} - ${teacherObject.price} crediti`
        };
        setTeachersOptions(teachersOptions => [
          ...teachersOptions,
          teacherOptionObject
        ]);
      }
    });
  }, [studentsData, teachersData]);

  const setSelectedStudents = studentsList => {
    setStudents(prevState => ({
      ...prevState,
      selected: studentsList
    }));
  };

  const setStudentsPrice = price => {
    setStudents(prevState => ({
      ...prevState,
      totalPrice: price
    }));
  };

  const setSelectedTeacher = teacherObject => {
    setTeacher(prevState => ({
      ...prevState,
      selected: teacherObject
    }));
  };

  const setTeacherPrice = price => {
    setTeacher(prevState => ({
      ...prevState,
      totalPrice: price
    }));
  };

  const handleStudentsField = (selectedStudents, context) => {
    setSelectedStudents(selectedStudents);
    if (context.action === 'select-option') {
      setStudentsPrice(
        students.totalPrice + studentsData[context.option.value].price
      );
    }
    if (context.action === 'remove-value') {
      setStudentsPrice(
        students.totalPrice - studentsData[context.removedValue.value].price
      );
    }
    if (context.action === 'clear') {
      setStudentsPrice(0);
    }
  };

  const handleTeacherField = (selectedTeacher, context) => {
    setSelectedTeacher(selectedTeacher);
    if (context.action === 'select-option') {
      setTeacherPrice(teachersData[selectedTeacher.value].price);
    } else if (
      context.action === 'remove-value' ||
      context.action === 'clear'
    ) {
      setTeacherPrice(0);
    }
  };

  const [credits, setCredits] = useState(100);

  useEffect(() => {
    setCredits(100 - teacher.totalPrice - students.totalPrice);
  }, [teacher.totalPrice, students.totalPrice]);

  useEffect(() => {
    if (credits >= 0 && teacher.selected && students.selected.length === 4) {
      setShouldContinue(true);
    } else {
      setShouldContinue(false);
    }
  }, [credits, teacher.selected, students.selected]);

  return (
    <>
      <div className="mb-4">
        <TeamHeader name={teamName} description={teamDescription} />
      </div>
      <div className="mb-3">
        <Flex>
          <label className="flex-grow-1 h5">Professore Caposquadra</label>
          <div className={teacher.selected ? 'text-success' : 'text-danger'}>
            <label className="h5" style={{ color: 'inherit' }}>
              {teacher.selected ? '1' : '0'}
            </label>
            <label>/1</label>
          </div>
        </Flex>
        <ReactSelect
          options={teachersOptions}
          value={teacher.selected}
          onChange={handleTeacherField}
          placeholder={<span className="text-400">Seleziona professore</span>}
          isClearable
        />
      </div>
      <div className="mb-4">
        <Flex>
          <label className="flex-grow-1 h5">Studenti</label>
          <div
            className={
              students.selected.length < 4 ? 'text-danger' : 'text-success'
            }
          >
            <label className="h5" style={{ color: 'inherit' }}>
              {students.selected.length}
            </label>
            <label>/4</label>
          </div>
        </Flex>
        <ReactSelect
          options={studentsOptions}
          value={students.selected}
          onChange={handleStudentsField}
          placeholder={<span className="text-400">Seleziona gli studenti</span>}
          noOptionsMessage={() => 'Nessuna scelta disponibile'}
          isOptionDisabled={() => students.selected.length >= 4}
          closeMenuOnSelect={false}
          isClearable
          isMulti
        />
      </div>
      <div className="col-6 d-lg-block">
        <h6 className="mb-1 text-900">Crediti rimanenti</h6>
        <h5 className="fs-6 fw-normal mb-0 ">
          <span className={credits < 0 ? 'text-danger' : 'text-success'}>
            {credits}
          </span>
        </h5>
        <div
          className={'invalid-feedback ' + (credits < 0 ? 'd-block' : 'd-none')}
        >
          {credits < 0 && 'Crediti insufficienti.'}
        </div>
      </div>
    </>
  );
};

Step3.propTypes = {
  teamName: PropTypes.string.isRequired,
  teamDescription: PropTypes.string.isRequired,
  students: PropTypes.object.isRequired,
  setStudents: PropTypes.func.isRequired,
  studentsData: PropTypes.object.isRequired,
  teacher: PropTypes.object.isRequired,
  setTeacher: PropTypes.func.isRequired,
  teachersData: PropTypes.object.isRequired,
  setShouldContinue: PropTypes.func.isRequired
};

export default Step3;
